// @flow
import React from 'react';
import styled from 'styled-components';

type Error404Props = {};

const StyledError404 = styled.div`
  width: 100%;
  height: 100%;
  font-weight: bold;
  margin: auto;
  text-align: center;
  padding: 1em;
`;

// eslint-disable-next-line no-unused-vars
export default function Error404(props: Error404Props) {
  return <StyledError404>This page does not exist.</StyledError404>;
}
